const parseFaqCategory = (url) => url.toLowerCase().replace(/\s/g, '');

export default parseFaqCategory;
